export default __webpack_public_path__ + "static/illustration-content-title.url-b3129835ce89b742782c1732f742a17a.svg";